import { ONE_SECOND_MS } from '@shared/utils/constants/time';
import { ContentTooLargeError } from '../errors';

export async function withRetry<T>(fn: () => Promise<T>, maxRetry = 3, allowErrors = false, retryCount = 1): Promise<T> {
  try {
    return await fn();
  } catch (err) {
    if (!(err instanceof ContentTooLargeError)) {
      if (retryCount < maxRetry) {
        console.log(`Attempt error: ${err}, retrying ${retryCount}/${maxRetry}`);
        // sleep exponentially longer each time
        await new Promise(resolve => setTimeout(resolve, ONE_SECOND_MS * Math.pow(2, retryCount)));
        return await withRetry(fn, maxRetry, allowErrors, retryCount + 1);
      }
      if (!allowErrors) {
        console.error(`Error: ${err}, no more retries left, throwing error`);
      }
    }
    if (!allowErrors) {
      throw err;
    } else {
      return undefined as T;
    }
  }
}
